import React from 'react';
import { Clock, AlertTriangle, CheckCircle2, Pause } from 'lucide-react';
import { SLAStatus, SLAResult, calculateSLA, DEFAULT_SLA_RULES } from '../../types/sla';

interface SLABadgeProps {
  createdAt: string;
  priorityName: string;
  completedAt?: string;
  compact?: boolean;
}

const STATUS_CONFIG: Record<SLAStatus, { icon: React.ReactNode; bg: string; text: string }> = {
  on_time: { icon: <Clock className="w-3 h-3" />, bg: 'bg-emerald-500/10 text-emerald-400 border-emerald-500/20', text: 'On Time' },
  due_soon: { icon: <AlertTriangle className="w-3 h-3" />, bg: 'bg-amber-500/10 text-amber-400 border-amber-500/20', text: 'Due Soon' },
  overdue: { icon: <AlertTriangle className="w-3 h-3" />, bg: 'bg-rose-500/10 text-rose-400 border-rose-500/20', text: 'Overdue' },
  breached: { icon: <AlertTriangle className="w-3 h-3" />, bg: 'bg-rose-500/10 text-rose-400 border-rose-500/20', text: 'SLA Breached' },
  paused: { icon: <Pause className="w-3 h-3" />, bg: 'bg-slate-500/10 text-slate-400 border-slate-500/20', text: 'Paused' },
  completed: { icon: <CheckCircle2 className="w-3 h-3" />, bg: 'bg-emerald-500/10 text-emerald-400 border-emerald-500/20', text: 'Completed' },
};

export const SLABadge: React.FC<SLABadgeProps> = ({ createdAt, priorityName, completedAt, compact }) => {
  const result: SLAResult = calculateSLA(createdAt, priorityName, DEFAULT_SLA_RULES, completedAt);
  const config = STATUS_CONFIG[result.status];

  return (
    <div className={`inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full text-[10px] font-semibold border ${config.bg}`}>
      {config.icon}
      {compact ? config.text : result.remaining_text}
    </div>
  );
};
